import React, { useState } from 'react';
import { useAuth } from '../app/providers/AuthProvider';

const IS_DEV = process.env.NODE_ENV === 'development';

export default function Login() {
  const { loginWithGoogle, devLogin } = useAuth();
  const [error, setError] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('error') ? decodeURIComponent(params.get('error')) : '';
  });
  const [devLoading, setDevLoading] = useState(false);

  const handleDevLogin = async () => {
    setDevLoading(true);
    const result = await devLogin();
    if (!result.success) {
      setError(result.error || 'Dev login failed.');
      setDevLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh',
      background: '#f1f2f6',
      fontFamily: "'Noto Sans', sans-serif",
    }}>
      <div style={{
        background: '#ffffff', borderRadius: 16, padding: '48px 44px',
        boxShadow: '0 8px 40px rgba(0,0,0,.10)', maxWidth: 420, width: '100%',
        border: '1px solid #e6e6e6', textAlign: 'center',
      }}>
        {/* Logo mark */}
        <img rel="icon" src="/logo/logo-raincode-color.svg" alt="Raincode" style={{ width: 40, marginBottom: 12 }}/>
        <div style={{
          width: 100, height: 52, borderRadius: 14,
          background: 'linear-gradient(135deg, rgb(64,117,193), rgb(60,81,126))',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 18px', fontSize: 22, color: '#fff', fontWeight: 800,
        }}><img rel="icon" src="/logo/logo-raincode-white.svg" alt="Raincode" style={{ width: 100, marginBottom: 0 }}/></div>

        {/* <div style={{ fontSize: 9, fontWeight: 700, color: 'rgb(64,117,193)', letterSpacing: '.22em', textTransform: 'uppercase', marginBottom: 6 }}>
          Raincode
        </div> */}
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#121212', marginBottom: 6, lineHeight: 1.2 }}>
          Situation Room
        </h1>
        <p style={{ color: '#6b6b6b', marginBottom: 36, fontSize: 13 }}>
          Sign in with your @raincode.tech account
        </p>

        {error && (
          <div style={{
            background: 'rgba(239,68,68,.07)', color: '#dc2626',
            border: '1px solid rgba(239,68,68,.25)', padding: '10px 14px',
            borderRadius: 8, marginBottom: 20, fontSize: 13, textAlign: 'left',
          }}>
            {error}
          </div>
        )}

        {/* Primary — backend OAuth */}
        <button
          onClick={loginWithGoogle}
          style={{
            width: '100%', padding: '12px 20px', borderRadius: 8,
            background: '#fff', border: '1px solid #e6e6e6', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            fontSize: 14, fontWeight: 600, color: '#121212',
            boxShadow: '0 1px 4px rgba(0,0,0,.08)', transition: 'all .15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 3px 12px rgba(0,0,0,.13)'; e.currentTarget.style.borderColor = '#d0d0d0'; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,.08)'; e.currentTarget.style.borderColor = '#e6e6e6'; }}
        >
          <GoogleIcon />
          Sign in with Google
        </button>

        {/* Dev bypass */}
        {IS_DEV && (
          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: 10, color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 8 }}>
              Dev only
            </div>
            <button
              onClick={handleDevLogin}
              disabled={devLoading}
              style={{
                width: '100%', padding: '10px', background: '#f1f2f6',
                border: '1px solid #e6e6e6', borderRadius: 8,
                color: devLoading ? '#a8a8a8' : '#6b6b6b',
                cursor: devLoading ? 'not-allowed' : 'pointer', fontSize: 13,
                fontFamily: "'Noto Sans', sans-serif",
              }}
            >
              {devLoading ? 'Signing in…' : '⚙ Dev Login (bypass Google OAuth)'}
            </button>
          </div>
        )}

        <div style={{
          marginTop: 28, padding: '14px 16px', background: '#f8f9fc',
          border: '1px solid #e6e6e6', borderRadius: 8, fontSize: 12, color: '#6b6b6b', textAlign: 'left',
        }}>
          <strong style={{ color: '#121212', fontWeight: 700 }}>Access Requirements</strong>
          <ul style={{ margin: '8px 0 0 0', paddingLeft: 18, lineHeight: 1.75 }}>
            <li>Must use a @raincode.tech Google account</li>
            <li>Must be invited by an admin</li>
            <li>First user automatically becomes Super Admin</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}
